export default "__VITE_ASSET__B3DDb5h$__"